            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="id_list_documento"
            :lg="2">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="documento"
            :lg="3">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="dv"
            :lg="1">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="nombre"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="name"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="direccion"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="telefonos"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            class="text-lowercase"
            inputTabla="datos_razon"
            inputCampo="email"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="id_list_arl"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="id_list_ccf"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_razon"
            inputCampo="id_list_aportante"
            :lg="6">
          </sw-inputs>
          <b-col :md="6" :lg="6"></b-col>
          <sw-inputs
            style="margin-top:15px"
            inputTabla="datos_razon"
            inputCampo="exonerado"
            :lg="6">
          </sw-inputs>     
          <sw-inputs
            style="margin-top:15px"
            inputTabla="datos_razon"
            inputCampo="retiroparafiscales"
            :lg="6">
          </sw-inputs>     
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="razon"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalrazon',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  async created()
  {
    if (this.dataIndex[this.namePath]!==false)
    {      
      await this.updateDataForm({state:'datos_razon', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_razon})
    }
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  computed: { 
  },
  destroyed()
  {    
		this.resetDataIndex()
		this.resetDataForm()
		this.resetDataPost()
  },
  methods: {
    save(event)
    {
     this.$emit('save', { save: event.save, ftn: 'razonFtn' } )
    }
  }
}
</script>
<style>
</style>